import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import moment from 'moment';

import { Main, Filter } from 'Containers';
import { CreateEditPurchaseOrderEnum, ItemEnum } from 'Common/FieldEnum';
import { CREATE_EDIT_PURCHASE_ORDER_FORM_NAME } from 'Common/FormEnum';
import { LoadingPage, DirtyWrapper } from 'Components';
import { DATE_FORMAT_FOR_UI, DATE_FORMAT_FOR_SERVER } from 'Common/Constants';
import { submitForm, resetForm, destroyForm } from 'State/forms/actions';
import { errorToast, createToast, toastType } from 'Common/ToastHelper';
import {
  BooleanStringEnum,
  StatusOptionEnum,
} from 'Common/Constants/Enumeration/ManagePurchaseOrderEnum';
import { resetDirty } from 'State/dirtyTracking/actions';
import { OrdertypeEnum } from 'Common/Constants/Enumeration/ManagePurchaseOrderEnum';
import { clearTableSavedState } from 'Common/FormHelper';
import { setTableStates } from 'Common/UserSettings/state/actions';
import { getTableStates } from 'Common/UserSettings/helpers/helper';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';

import {
  getPODetail,
  getPOItems,
  savePOWO,
  emptyItemList,
  emptyEditObject,
  clearInvalidPreviewData,
  clearPOWOSubmitError,
  clearPurchaseOrderError,
} from '../../state/managePurchasseOrder/actions';
import { CreateEditPurchaseOrder } from '../createEditPurchaseOrder/CreateEditPurchaseOrder';
import { PreviewPurchaseOrder } from '../createEditPurchaseOrder/PreviewPurchaseOrder';
import { getSavePOWOObject, basicURL } from './../../helper';

class CreateEditPurchaseOrderWizardFormContainer extends Component {
  static path =
    `${basicURL}/purchase/powo/:PONum/:SiteId/:IsWarehouseOrder/:IsNonInventoryPO`;
  state = {
    page: 1,
    resetPageOnDataChange: true,
    activeIndexForFilter: 0,
  };

  componentDidMount() {
    const { PONum, SiteId, IsWarehouseOrder } = this.props.match.params;
    const { getPODetail, getPOItems } = this.props;

    getPODetail({
      PONum,
      SiteId,
      IsWarehouseOrder: IsWarehouseOrder !== OrdertypeEnum.PO,
      IsNonInventoryPO: BooleanStringEnum.FALSE,
    }).then(() => {
      const { selectedOrderDetail, isDisabled } = this.props;
      selectedOrderDetail &&
      !isDisabled &&
      IsWarehouseOrder === OrdertypeEnum.PO &&
      getPOItems(
        {
          DeliveryDT: selectedOrderDetail[
            CreateEditPurchaseOrderEnum.DeliveryDT
            ]
            ? moment(
              selectedOrderDetail[CreateEditPurchaseOrderEnum.DeliveryDT]
            ).format(DATE_FORMAT_FOR_SERVER)
            : null,
          VendorId: selectedOrderDetail[CreateEditPurchaseOrderEnum.VendorId],
          SiteId,
          GLRelatedPO: BooleanStringEnum.FALSE,
          IsWarehouse: IsWarehouseOrder !== OrdertypeEnum.PO,
        },
        selectedOrderDetail[CreateEditPurchaseOrderEnum.POItemDetails]
      );
    });
    this.props.resetDirty();
  }
  getBreadCrumbs = () => {
    const { page } = this.state;
    const { IsWarehouseOrder } = this.props.match.params;
    let breadcrumbs = [
      {
        title: 'Manage Orders',
        link: `${basicURL}`,
      },
      {
        title:
          IsWarehouseOrder === OrdertypeEnum.PO
            ? 'Edit PO'
            : IsWarehouseOrder === OrdertypeEnum.WO
            ? 'Edit WO'
            : 'Edit KO',
        link: '',
      },
    ];
    if (page === 1) {
      breadcrumbs[1].link = '';
    }
    if (page === 2) {
      breadcrumbs.push({
        title: 'Order Items',
        link: '',
      });
    }
    return breadcrumbs;
  };
  getRootUrl = () => {
    return `${basicURL}`;
  };

  getMainProps = showDirtyConfirm => {
    const { page } = this.state;
    const { IsWarehouseOrder } = this.props.match.params;
    const {
      poItemDetails,
      isDisabled,
      gridPreferenceLoading,
      gridPreferenceSubmitting,
    } = this.props;
    let toolbox = {
      backButtonProps: { shown: true, path: this.getRootUrl() },
      shown: true,
      rightButtons: [],
    };
    !isDisabled &&
    toolbox.rightButtons.push({
      content:
        IsWarehouseOrder === OrdertypeEnum.PO
          ? 'Preview PO Items'
          : IsWarehouseOrder === OrdertypeEnum.WO
          ? 'Preview WO Items'
          : 'Preview KO Items',
      onClick: this.onPreviewOrderItemsClick,
      disabled:
        gridPreferenceLoading ||
        gridPreferenceSubmitting ||
        !poItemDetails ||
        !poItemDetails.length,
    });
    if (page === 2) {
      delete toolbox.backButtonProps;
      toolbox.rightButtons = [
        {
          content: 'Previous Page',
          onClick: this.previousPage,
          disabled: gridPreferenceLoading || gridPreferenceSubmitting,
        },
        {
          content:
            IsWarehouseOrder === OrdertypeEnum.PO
              ? 'Save PO'
              : IsWarehouseOrder === OrdertypeEnum.WO
              ? 'Save WO'
              : 'Save KO',
          onClick: this.handleSave,
        },
        {
          content: 'Cancel',
          onClick: showDirtyConfirm,
        },
      ];
    }
    return {
      toolbox,
    };
  };
  resetScroll = () => this.props.scrollMainTo(0, 0);
  handleSubmit = values => {
    const { IsWarehouseOrder } = this.props.match.params;
    this.props.savePOWO(
      getSavePOWOObject(
        values,
        IsWarehouseOrder !== OrdertypeEnum.PO,
        this.props.selectedOrderDetail[
          CreateEditPurchaseOrderEnum.TransactionId
          ]
      ),
      this.resetScroll
    );
  };
  handleSave = e => {
    this.props.submitForm(CREATE_EDIT_PURCHASE_ORDER_FORM_NAME);
  };

  onPreviewOrderItemsClick = () => {
    const { history, allTableStates, setTableStates } = this.props;
    clearTableSavedState(history, '', allTableStates, setTableStates, [
      TableNamesEnum.PURCHASE_ORDER_CREATE_EDIT_TABLE,
    ]);
    this.setState({ page: this.state.page + 1, resetPageOnDataChange: true });
  };
  onCancelClick = () => {
    this.props.history.push(`${basicURL}`);
  };
  componentDidUpdate(prevProps) {
    const { clearPOWOSubmitError, clearPurchaseOrderError } = this.props;
    if (
      errorToast(this.props, prevProps, 'editPOWOLoadingError') ||
      errorToast(this.props, prevProps, 'editPOWOItemsLoadingError') ||
      errorToast(this.props, prevProps, 'submitError')
    ) {
      clearPOWOSubmitError();
      clearPurchaseOrderError();
    } else if (this.props.submitted && !prevProps.submitted) {
      createToast(toastType.success, 'Success', 'Order has been saved', true);

      clearPOWOSubmitError();
    }
  }
  componentWillUnmount() {
    const { emptyItemList, selectedOrderDetail, emptyEditObject } = this.props;
    this.completeReset();
    emptyItemList();
    if (selectedOrderDetail) {
      emptyEditObject();
    }
  }
  completeReset = () => {
    this.props.resetForm(CREATE_EDIT_PURCHASE_ORDER_FORM_NAME);
    this.props.destroyForm(CREATE_EDIT_PURCHASE_ORDER_FORM_NAME);
  };
  getCreatePageAndPreviewPage = () => {
    const { page } = this.state;
    const { SiteId, PONum, IsWarehouseOrder } = this.props.match.params;
    const {
      selectedOrderDetail,
      isDisabled,
      fetchEditPOWOItems,
      editPOWOItems,
      poItemDetails,
      editPOWOLoadingError,
    } = this.props;

    let element = [];
    let render = false;
    let initialValues = {};
    let isEditPage = false;
    if (selectedOrderDetail) {
      render = true;
      isEditPage = true;
      initialValues = {
        [CreateEditPurchaseOrderEnum.SiteName]:
          selectedOrderDetail[CreateEditPurchaseOrderEnum.SiteName],
        [CreateEditPurchaseOrderEnum.PONum]:
          selectedOrderDetail[CreateEditPurchaseOrderEnum.PONum],
        [CreateEditPurchaseOrderEnum.DeliveryDT]: moment(
          selectedOrderDetail[CreateEditPurchaseOrderEnum.DeliveryDT]
        ).format(DATE_FORMAT_FOR_UI),
        [CreateEditPurchaseOrderEnum.PODate]:
        selectedOrderDetail[CreateEditPurchaseOrderEnum.PODate] &&
        moment(
          selectedOrderDetail[CreateEditPurchaseOrderEnum.PODate]
        ).format(DATE_FORMAT_FOR_UI),
        [CreateEditPurchaseOrderEnum.VendorName]:
          selectedOrderDetail[CreateEditPurchaseOrderEnum.VendorName],
        [CreateEditPurchaseOrderEnum.OrderIds]:
          selectedOrderDetail[CreateEditPurchaseOrderEnum.OrderIds],
        [CreateEditPurchaseOrderEnum.Comments]:
          selectedOrderDetail[CreateEditPurchaseOrderEnum.Comments],
        [CreateEditPurchaseOrderEnum.BudgetCode]:
          selectedOrderDetail[CreateEditPurchaseOrderEnum.BudgetCode],
        [CreateEditPurchaseOrderEnum.EncumbranceCode]:
          selectedOrderDetail[CreateEditPurchaseOrderEnum.EncumbranceCode],
        [CreateEditPurchaseOrderEnum.ShippingCost]:
          selectedOrderDetail[CreateEditPurchaseOrderEnum.ShippingCost],
        [CreateEditPurchaseOrderEnum.POItemDetails]:
          selectedOrderDetail[CreateEditPurchaseOrderEnum.POItemDetails],
      };
    } else if (editPOWOLoadingError) {
      render = true;
      initialValues = {
        [CreateEditPurchaseOrderEnum.SiteName]: SiteId,
        [CreateEditPurchaseOrderEnum.PONum]: PONum,
        [CreateEditPurchaseOrderEnum.DeliveryDT]: moment().format(
          DATE_FORMAT_FOR_UI
        ),
        [CreateEditPurchaseOrderEnum.PODate]: moment().format(
          DATE_FORMAT_FOR_UI
        ),
        [CreateEditPurchaseOrderEnum.VendorName]: '',
        [CreateEditPurchaseOrderEnum.OrderIds]: 0,
        [CreateEditPurchaseOrderEnum.Comments]: '',
        [CreateEditPurchaseOrderEnum.BudgetCode]: '',
        [CreateEditPurchaseOrderEnum.EncumbranceCode]: '',
        [CreateEditPurchaseOrderEnum.ShippingCost]: '',
        [CreateEditPurchaseOrderEnum.POItemDetails]: [],
      };
    }
    if (render) {
      page === 1
        ? element.push(
        <CreateEditPurchaseOrder
          key={`newEdit${page}`}
          initialValues={initialValues}
          isDisabled={isDisabled}
          SiteId={SiteId}
          fetchEditPOWOItems={fetchEditPOWOItems}
          editPOWOItems={editPOWOItems}
          poItemDetails={poItemDetails}
          resetPageOnDataChange={this.state.resetPageOnDataChange}
          onResetPageOnDataChange={this.onResetPageOnDataChange}
          activeIndexForFilter={this.state.activeIndexForFilter}
          handleClick={this.handleClick}
          isEditPage={isEditPage}
          IsWarehouseOrder={IsWarehouseOrder}
          selectedOrderDetail={selectedOrderDetail}
        />
        )
        : element.push(
        <PreviewPurchaseOrder
          key={`preview${page}`}
          initialValues={initialValues}
          SiteId={SiteId}
          onSubmit={this.handleSubmit}
          fetchEditPOWOItems={fetchEditPOWOItems}
          editPOWOItems={editPOWOItems}
          poItemDetails={poItemDetails}
          resetPageOnDataChange={this.state.resetPageOnDataChange}
          onResetPageOnDataChange={this.onResetPageOnDataChange}
          isEditPage={isEditPage}
          IsWarehouseOrder={IsWarehouseOrder}
        />
        );
    }
    return element;
  };
  previousPage = () => {
    const { poItemDetails, clearInvalidPreviewData } = this.props;
    const data = poItemDetails.filter(item => {
      return item[ItemEnum.PrimaryQty] || item[ItemEnum.SecondaryQty];
    });
    clearInvalidPreviewData(data);
    this.setState({ page: this.state.page - 1, resetPageOnDataChange: true });
  };

  onResetPageOnDataChange = () => {
    this.setState({ resetPageOnDataChange: false });
  };

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndexForFilter } = this.state;
    const newIndex = activeIndexForFilter === index ? -1 : index;
    this.setState({
      activeIndexForFilter: newIndex,
    });
  };

  render() {
    const {
      loading,
      submitting,
      fetchEditPOWODetail,
      selectedOrderDetail,
      isReadOnly,
    } = this.props;
    return loading || submitting || fetchEditPOWODetail ? (
      <LoadingPage />
    ) : (
      <Fragment>
        <Filter title={''} breadcrumbs={this.getBreadCrumbs()}>
          <div style={{ paddingTop: 10 }}>
            <div style={{ float: 'right' }}>
              Order Date:{' '}
              {selectedOrderDetail &&
              selectedOrderDetail[CreateEditPurchaseOrderEnum.PODate] &&
              moment(
                selectedOrderDetail[CreateEditPurchaseOrderEnum.PODate]
              ).format(DATE_FORMAT_FOR_UI)}
            </div>
          </div>
        </Filter>
        <DirtyWrapper
          closeModalYesCallback={this.onCancelClick}
          isReadOnly={isReadOnly}
        >
          {showDirtyConfirm => (
            <Main
              {...this.getMainProps(showDirtyConfirm)}
              shouldNotUsePageWidth
            >
              {this.getCreatePageAndPreviewPage()}
            </Main>
          )}
        </DirtyWrapper>
      </Fragment>
    );
  }
}

const selector = formValueSelector(CREATE_EDIT_PURCHASE_ORDER_FORM_NAME);
const mapStateToProps = state => {
  const {
    PurchaseOrderState: { managePurchaseOrder },
    CommonState: { gridPreference },
  } = state;
  const { selectedOrderDetail } = managePurchaseOrder;
  const isDisabled =
    selectedOrderDetail &&
    selectedOrderDetail[CreateEditPurchaseOrderEnum.Status] ===
    StatusOptionEnum.CLOSED;

  return {
    poItemDetails: selector(state, [CreateEditPurchaseOrderEnum.POItemDetails]),
    isDisabled: isDisabled,
    fetchEditPOWODetail: managePurchaseOrder.fetchEditPOWODetail,
    selectedOrderDetail,
    editPOWOLoadingError: managePurchaseOrder.editPOWOLoadingError,
    fetchEditPOWOItems: managePurchaseOrder.fetchEditPOWOItems,
    editPOWOItems: managePurchaseOrder.editPOWOItems,
    editPOWOItemsLoadingError: managePurchaseOrder.editPOWOItemsLoadingError,
    submitting: managePurchaseOrder.submitting,
    submitted: managePurchaseOrder.submitted,
    submitError: managePurchaseOrder.submitError,
    gridPreferenceLoading: gridPreference.loading,
    gridPreferenceSubmitting: gridPreference.isSubmitting,
    allTableStates: getTableStates(state),
  };
};

export const CreateEditPurchaseOrderWizardForm = connect(
  mapStateToProps,
  {
    getPODetail,
    getPOItems,
    savePOWO,
    emptyItemList,
    emptyEditObject,
    submitForm,
    resetForm,
    destroyForm,
    clearInvalidPreviewData,
    clearPOWOSubmitError,
    clearPurchaseOrderError,
    resetDirty,
    setTableStates,
  }
)(CreateEditPurchaseOrderWizardFormContainer);



// WEBPACK FOOTER //
// ./src/pages/inventory/managepurchaseorder/containers/subpages/CreateEditPurchaseOrderWizardForm.js